
import { computed, defineComponent, onMounted, watch, watchEffect, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import moment from "moment";
import FacultySubmmitButton from "@/views/pages/application/faculty/FacultySubmmitButton.vue";
import DocumentsRO from "@/views/pages/application/view/tabs/Document.vue";

interface FacultyDetails {
  degree: string;
  email: string;
  fullname: string;
  research_description: string;
  address: string;
}

export default defineComponent({
  name: "kt-vertical-wizard",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    getTextQuestion1(arg){
      if(arg == "Written Consent") {
        return "Written (or electronic)";
      } else if (arg == "Oral Consent") {
        return "Oral";
      } else if (arg == "Waiver") {
        return "Request for consent to be waived";
      }
      return arg;
    },
  },
  components: {
    FacultySubmmitButton,
    DocumentsRO,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const currentResearch = computed(() => {
      return store.getters.currentResearch;
    });

    const currentRisk = computed(() => {
      return store.getters.currentRisk;
    });

    const currentSubject = computed(() => {
      return store.getters.currentSubject;
    });

    const currentCoInvestigators = computed(() => {
      return store.getters.currentCoInvestigators;
    });

    const currentInformed = computed(() => {
      return store.getters.currentInformed;
    });

    const currentRecruitment = computed(() => {
      return store.getters.currentRecruitment;
    });


    const facultyDetails = ref<FacultyDetails>({
      degree: "",
      email: "",
      fullname: "",
      research_description: "",
      address: "",
    });
    const currentFaculty = computed(() => {
      return store.getters.currentFaculty;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication !== null
        ? store.getters.currentApplication.data
        : {};
    });

    const currentIrbReviewer = computed(() => {
      return store.getters.currentIrbReviewer;
    });

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const IsIrbChair = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbchair") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsIrbMember = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbmember") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const investigatorName = computed(() => {
      const principalInvestigator = store.getters.currentCoInvestigators;
      return principalInvestigator != null && principalInvestigator.length > 0 && principalInvestigator[0].type == "Principal Investigator"? principalInvestigator[0].firstname + " " + principalInvestigator[0].lastname : "na";
    });

    const investigatorPhone = computed(() => {
      const principalInvestigator = store.getters.currentCoInvestigators;
      return principalInvestigator != null && principalInvestigator.length > 0  && principalInvestigator[0].type == "Principal Investigator"? principalInvestigator[0].phone : "na";
    });

    const IsStudentInvestigator = computed(() => {
      if (
        store.getters.currentCoInvestigators != null &&
        store.getters.currentCoInvestigators.length > 0 &&
        store.getters.currentCoInvestigators[0].role != null &&
        store.getters.currentCoInvestigators[0].role.indexOf("student") !== -1
      ) {
        return "Yes";
      }
      return "No";
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RESEARCH, route.params.id);
      store.dispatch(Actions.GET_IRB_APPLICATION_SUBJECT, route.params.id);
      store.dispatch(Actions.GET_IRB_APPLICATION_RECRUITMENT, route.params.id);
      store.dispatch(Actions.GET_IRB_APPLICATION_RISK, route.params.id);
      store.dispatch(Actions.GET_IRB_APPLICATION_INFORMED, route.params.id);
      
      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

  

    watchEffect(() => {
      const data = store.getters.currentFaculty;
      if (data === null) return;
      console.log(data.data);
      facultyDetails.value.degree =
        data.data !== undefined ? data.data.sponsorDegree : "";
      facultyDetails.value.email =
        data.data !== undefined ? data.data.email : "";
      facultyDetails.value.fullname =
        data.data !== undefined ? data.data.fullname : "";
      facultyDetails.value.research_description =
        data.data !== undefined ? data.data.reseachDescription : "";
      facultyDetails.value.address =
        data.data !== undefined ? data.data.address : "";
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(
          Actions.GET_IRB_APPLICATION_RESEARCH,
          route.params.id
        );
      }
    );

    return {
      currentResearch,
      currentApplication,
      currentIrbReviewNote,
      currentIrbReviewer,
      currentUser,
      IsIrbMember,
      IsIrbChair,
      currentCoInvestigators,
      currentSubject,
      currentRecruitment,
      currentRisk,
      currentInformed,
      currentFaculty,
      IsStudentInvestigator,
      facultyDetails,
      investigatorName,
      investigatorPhone,
    };
  },
});
